import React, { createContext, useState } from "react";
import { Estados } from "./../../../../repositories/qerpapi/erp/prouser/static/Estados";
import { Municipios } from "./../../../../repositories/qerpapi/erp/prouser/static/Municipios";
import { Paises } from "./../../../../repositories/qerpapi/erp/prouser/static/Paises";

const TransportadoraContext = createContext();

const TransportadoraContextProvider = ({ children }) => {
  const [transportadoraId, setTransportadoraId] = useState(null);
  const [tipoCpfCnpj, setTipoCpfCnpj] = useState({
    description: "CNPJ",
    value: "cnpj",
  });

  const [cpfCnpj, setCpfCnpj] = useState("");
  const [name, setName] = useState("");
  const [fantasy, setFantasy] = useState("");

  const [cep, setCep] = useState("");
  const [address, setAddress] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [district, setDistrict] = useState("");

  const [uf, setUf] = useState(null);
  const [county, setCounty] = useState(null);

  const [nation, setNation] = useState({ codigo: "1058", descricao: "BRASIL" });

  const [email, setEmail] = useState("");
  const [active, setActive] = useState(true);
  const [telephone1, setTelephone1] = useState("");

  const [telephone2, setTelephone2] = useState("");
  const [contato, setContato] = useState(null);
  const [celular, setCelular] = useState("");
  const [whatsappActive, setWhatsappActive] = useState(false);

  const [ieRg, setIeRg] = useState("");
  const [rntrc, setRntrc] = useState(null);

  const [errors, setErrors] = useState({});

  const [listCounty, setListCounty] = useState([...Municipios]);
  const [listUf, setListUf] = useState([...Estados]);
  const [listNation, setListNation] = useState([...Paises]);

  const [loading, setLoading] = useState(false);
  const [loadingInputs, setLoadingInputs] = useState({});

  const [optionsPais, setOptionsPais] = useState([
    { codigo: "1058", descricao: "BRASIL" },
  ]);
  const [optionsEstado, setOptionsEstado] = useState([]);
  const [optionsMunicipio, setOptionsMunicipio] = useState([]);
  const [validCpfCnpj, setValidCpfCnpj] = useState(false);

  return (
    <TransportadoraContext.Provider
      value={{
        tipoCpfCnpj,
        setTipoCpfCnpj,
        name,
        setName,
        fantasy,
        setFantasy,
        cep,
        setCep,
        address,
        setAddress,
        number,
        setNumber,
        complement,
        setComplement,
        district,
        setDistrict,
        uf,
        setUf,
        county,
        setCounty,
        nation,
        setNation,

        telephone1,
        setTelephone1,

        telephone2,
        setTelephone2,
        email,
        setEmail,
        ieRg,
        setIeRg,
        rntrc,
        setRntrc,
        contato,
        setContato,
        errors,
        setErrors,

        listCounty,
        setListCounty,
        listUf,
        setListUf,
        listNation,
        setListNation,

        cpfCnpj,
        setCpfCnpj,

        transportadoraId,
        setTransportadoraId,

        loading,
        setLoading,
        optionsPais,
        setOptionsPais,
        optionsEstado,
        setOptionsEstado,
        optionsMunicipio,
        setOptionsMunicipio,
        loadingInputs,
        setLoadingInputs,
        active,
        setActive,
        celular,
        setCelular,
        whatsappActive,
        setWhatsappActive,
        validCpfCnpj,
        setValidCpfCnpj,
      }}
    >
      {children}
    </TransportadoraContext.Provider>
  );
};

export { TransportadoraContextProvider, TransportadoraContext };
